export default {"src":"/_next/static/media/profile-photo-placeholder-pink.8e6ce3d3.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};